<div class="parent" *ngIf="data?.length">
  <div class="grid" [ngStyle]="{'grid-template-columns': (isAdmin && !editMode ? 'repeat(3, 1fr)' : 'repeat(1, 1fr)')}">
    <span class="columnHeader" *ngFor="let t of columns">
      {{ t }}
    </span>
  </div>
  <div class="grid gridRow" [ngStyle]="{'grid-template-columns': (isAdmin && !editMode ? 'repeat(3, 1fr)' : 'repeat(1, 1fr)')}" *ngFor="let c of data">

    <span class="pertinent">
      <div style="width:100%; text-align:left; display: inline-block;">
        {{ c['specificationCategory'] }}
      </div>
      <!--
      <div style="width: 19%; display: inline-block; text-align: center;">
        <i *ngIf='isAdmin && editMode' (click)='removeItem(c)' class="fas fa-trash" title='Remove entry' style='cursor: pointer; color:#808080'></i>
      </div>
      -->
    </span>
    <span class="dateTime" style="text-align: left;" *ngIf="isAdmin && !editMode">{{ c['createdDateTime'] ? (c['createdDateTime'] | date:'medium') : 'N/A' }}</span>
    <span class="whodunit" style="text-align: left;" *ngIf="isAdmin && !editMode">{{ c['createdByUser'] ? c['createdByUser'] : 'N/A' }}</span>

  </div>
</div>
<div class="recordCount" *ngIf="!editMode">
  {{ data ? data.length : 0}} category record(s)
</div>
